import { render } from "./BoundaryAreaSelector.vue?vue&type=template&id=04655753&scoped=true"
import script from "./BoundaryAreaSelector.vue?vue&type=script&lang=js"
export * from "./BoundaryAreaSelector.vue?vue&type=script&lang=js"

import "./BoundaryAreaSelector.vue?vue&type=style&index=0&id=04655753&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04655753"]])

export default __exports__